import type { IBondScreenerPresetConfig, TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';

const FILTER_KEY_SECTION_IDS: Partial<Record<keyof TFilterPayload, FilterSectionIds>> = {
  includedProductIds: FilterSectionIds.CreditProducts,
  includedMarketIds: FilterSectionIds.Markets,
  includeUsIgNonCountables: FilterSectionIds.Markets,
  includedCurrencyIds: FilterSectionIds.Currency,
  excludedCurrencyIds: FilterSectionIds.Currency,
  isCurrencyExcluded: FilterSectionIds.Currency,
  includedTenorFrom: FilterSectionIds.Tenor,
  includedTenorTo: FilterSectionIds.Tenor,
  excludedTenorFrom: FilterSectionIds.Tenor,
  excludedTenorTo: FilterSectionIds.Tenor,
  isTenorExcluded: FilterSectionIds.Tenor,
  callable: FilterSectionIds.Tenor,
  perpetual: FilterSectionIds.Tenor,
  includedStatusIds: FilterSectionIds.Status,
  dropped: FilterSectionIds.Status,
  includedMaturityDateFrom: FilterSectionIds.MaturityDate,
  includedMaturityDateTo: FilterSectionIds.MaturityDate,
  includedCallDateFrom: FilterSectionIds.CallDate,
  includedCallDateTo: FilterSectionIds.CallDate,
  includedCouponTypeIds: FilterSectionIds.CouponTypes,
  includedRankingIds: FilterSectionIds.Rankings,
  includedRatingGroupIds: FilterSectionIds.Ratings,
  excludedRatingGroupIds: FilterSectionIds.Ratings,
  includedRatingAgencyIds: FilterSectionIds.RatingAgencies,
  excludedRatingAgencyIds: FilterSectionIds.RatingAgencies,
  includedBenchmarkGroupIds: FilterSectionIds.Benchmarks,
  includedRegistrationGroupIds: FilterSectionIds.Registrations,
  includedCouponFrom: FilterSectionIds.CouponRange,
  includedCouponTo: FilterSectionIds.CouponRange,
  includedPricingSpreadFrom: FilterSectionIds.PricingSpread,
  includedPricingSpreadTo: FilterSectionIds.PricingSpread,
  includedYieldFrom: FilterSectionIds.Yield,
  includedYieldTo: FilterSectionIds.Yield,
  includedXCoveredFrom: FilterSectionIds.XCovered,
  includedXCoveredTo: FilterSectionIds.XCovered,
  includedIptPxdFrom: FilterSectionIds.IptPxd,
  includedIptPxdTo: FilterSectionIds.IptPxd,
  includedAttritionFrom: FilterSectionIds.Attrition,
  includedAttritionTo: FilterSectionIds.Attrition,
  includedDealSizeFrom: FilterSectionIds.Size,
  includedDealSizeTo: FilterSectionIds.Size,
  includedTrancheSizeFrom: FilterSectionIds.Size,
  includedTrancheSizeTo: FilterSectionIds.Size,
  includedIndustryIds: FilterSectionIds.IndustriesSubindustries,
  includedSubindustryIds: FilterSectionIds.IndustriesSubindustries,
  selectedSubindustryIds: FilterSectionIds.IndustriesSubindustries,
  includedRegionIds: FilterSectionIds.RegionsCountries,
  includedCountryIds: FilterSectionIds.RegionsCountries,
  selectedCountryIds: FilterSectionIds.RegionsCountries,
  includedIssuerIds: FilterSectionIds.ParentsIssuers,
  excludedIssuerIds: FilterSectionIds.ParentsIssuers,
  includedParentIds: FilterSectionIds.ParentsIssuers,
  excludedParentIds: FilterSectionIds.ParentsIssuers,
  isParentsIssuersExcluded: FilterSectionIds.ParentsIssuers,
  issuedByHoldingCompany: FilterSectionIds.ParentsIssuers,
  issuedByOperatingCompany: FilterSectionIds.ParentsIssuers,
  includedTickerCompanyIds: FilterSectionIds.Ticker,
  excludedTickerCompanyIds: FilterSectionIds.Ticker,
  isTickerExcluded: FilterSectionIds.Ticker,
  includedEsgIds: FilterSectionIds.Esg,
  includedUseOfProceedsIds: FilterSectionIds.UseOfProceeds,
  excludedUseOfProceedsIds: FilterSectionIds.UseOfProceeds,
  isUseOfProceedsExcluded: FilterSectionIds.UseOfProceeds,
  includedListingIds: FilterSectionIds.Listing,
  includedIssuePriceFrom: FilterSectionIds.Price,
  includedIssuePriceTo: FilterSectionIds.Price,
  includedLeadIds: FilterSectionIds.Leads,
  excludedLeadIds: FilterSectionIds.Leads,
  isLeadsExcluded: FilterSectionIds.Leads,
  includedLeadRoleIds: FilterSectionIds.Leads,
  includedAdditionalFilters: FilterSectionIds.AdditionalFilters,
  excludedAdditionalFilters: FilterSectionIds.AdditionalFilters,
  isAdditionalFiltersExcluded: FilterSectionIds.AdditionalFilters,
};

export const getPresetSectionIds = (preset: IBondScreenerPresetConfig): FilterSectionIds[] => {
  const sectionIds = (Object.keys(preset.filters) as (keyof TFilterPayload)[])
    .map((key) => FILTER_KEY_SECTION_IDS[key])
    .filter((sectionId): sectionId is FilterSectionIds => sectionId !== undefined);

  return Array.from(new Set(sectionIds));
};
